import { gql } from "@apollo/client";

const ADMIN_USER_FIELDS = `
  externalId
  email
  firstName
  lastName
  avatarUrl
  isEnabled
  lastSignInAt
  permissions
`;

/**
 * Creates or replaces a user's admin access in one call.
 *
 * `permissions` is the complete set the user should end up with - the backend replaces
 * rather than merges, so revoking a permission is just omitting its code.
 */
export const UPSERT_ADMIN_USER = gql`
  mutation UpsertAdminUser($request: UpsertAdminUserRequestInput!) {
    upsertAdminUser(request: $request) {
      ${ADMIN_USER_FIELDS}
    }
  }
`;

/** Enables or disables a user's admin access without discarding their grants. */
export const SET_ADMIN_USER_ENABLED = gql`
  mutation SetAdminUserEnabled($externalId: String!, $isEnabled: Boolean!) {
    setAdminUserEnabled(externalId: $externalId, isEnabled: $isEnabled) {
      externalId
      isEnabled
    }
  }
`;

/** Revokes admin access entirely, removing the user from the list. */
export const REVOKE_ADMIN_USER = gql`
  mutation RevokeAdminUser($externalId: String!) {
    revokeAdminUser(externalId: $externalId)
  }
`;
